import FeedbackPage from '@/components/FeedbackPage'

export default function LearningProfileSummaryPage() {
  return (
    <FeedbackPage
      emoji="📋"
      title="pages.onboarding.learningProfileSummary.title"
    />
  )
}
